/*
 * CAMPIONE — temaya sonradan eklenen davranislar.
 * Prestige'in kendi theme.js dosyasina DOKUNULMAZ; eklemeler burada yasar.
 */

/*
 * <free-shipping-progress>
 *
 * Temanin <free-shipping-bar> bileseni sepet degistikce kendi "total-price"
 * ozniteligini gunceller ama gorsel bir ilerleme cubugu cizmez. Bu eleman ust
 * ogesindeki oznitelikleri izleyip doluluk oranini CSS degiskenine yazar.
 *
 * Ozel eleman olarak tanimlandigi icin sepet cekmecesi AJAX ile yeniden
 * cizildiginde de kendiliginden devreye girer (innerHTML ile eklenen <script>
 * calismaz, ozel eleman ise otomatik yukselir).
 */
if (!window.customElements.get('free-shipping-progress')) {
  class FreeShippingProgress extends HTMLElement {
    #bar = null;
    #observer = null;

    connectedCallback() {
      this.#bar = this.closest('free-shipping-bar');
      if (!this.#bar) return;

      this.#observer = new MutationObserver(() => this.#sync());
      this.#observer.observe(this.#bar, {
        attributes: true,
        attributeFilter: ['total-price', 'threshold'],
      });

      this.#sync();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    #sync() {
      const threshold = parseFloat(this.#bar.getAttribute('threshold'));
      const total = parseFloat(this.#bar.getAttribute('total-price'));

      if (!Number.isFinite(threshold) || threshold <= 0 || !Number.isFinite(total)) {
        this.style.setProperty('--free-shipping-progress', '0%');
        return;
      }

      const percent = Math.min(100, Math.max(0, (total / threshold) * 100));
      this.style.setProperty('--free-shipping-progress', `${percent.toFixed(2)}%`);
      this.#bar.toggleAttribute('data-reached', total >= threshold);
    }
  }

  window.customElements.define('free-shipping-progress', FreeShippingProgress);
}

/*
 * Footer'daki "Cookie-Einstellungen" butonu.
 *
 * dawnz'da bu satir inline onclick ile yazilmisti; burada olay dinleyicisine
 * cevrildi. Once temanin kendi gizlilik bannerini, o yoksa Shopify'in
 * onay yoneticisini acar.
 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-campione-cookie-preferences]');
  if (!trigger) return;

  event.preventDefault();

  if (window.privacyBanner?.showPreferences) {
    window.privacyBanner.showPreferences();
  } else if (window.Shopify?.customerPrivacy?.openConsentManager) {
    window.Shopify.customerPrivacy.openConsentManager();
  }
});

/*
 * <size-conflict-notice>
 *
 * Sepette ayni urun varken gorunur. Ilk durum sunucu tarafinda belirlenir;
 * bu eleman yalnizca sepet degistiginde gorunurlugu gunceller.
 */
if (!window.customElements.get('size-conflict-notice')) {
  class SizeConflictNotice extends HTMLElement {
    #onCartChanged = (event) => {
      const productId = parseInt(this.getAttribute('product-id'), 10);
      const items = event.detail?.cart?.items ?? [];
      const inCart = items.some((item) => item.product_id === productId);

      this.classList.toggle('hidden', !inCart);
    };

    connectedCallback() {
      document.addEventListener('cart:change', this.#onCartChanged);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this.#onCartChanged);
    }
  }

  window.customElements.define('size-conflict-notice', SizeConflictNotice);
}

/*
 * <campione-favorite> — favori (kalp) butonu.
 *
 * Secim TARAYICIYA kaydedilir (localStorage, anahtar "campione:favorites").
 * Sayfa yenilense de kalp dolu kalir; ama yalnizca o cihazda. Cihazlar arasi
 * tasima (giris yapmis musteride sunucuya senkron) ayri bir katman olarak
 * bunun uzerine gelecek: asagidaki favoriDeposu tek giris noktasi, senkron
 * oraya baglanacak.
 *
 * Neden ozel eleman: koleksiyon filtresi/sayfalama kartlari AJAX ile yeniden
 * ciziyor. Ozel eleman yeni eklenen kartta kendiliginden yukselir ve kayitli
 * durumu geri koyar; document uzerinde delege dinleyici bunu yapamazdi
 * (tiklamayi yakalardi ama dolu kalbi geri koyamazdi).
 *
 * localStorage her ortamda calismaz (gizli sekme, cerez engeli, kota). O
 * durumda bellek ici yedege duser: buton yine calisir, sadece sayfa
 * yenilenince unutulur -- hata verip kalbi kirmaktansa boylesi iyi.
 */
const FAVORI_ANAHTARI = 'campione:favorites';
const FAVORI_OLAYI = 'campione:favorites-changed';

const favoriDeposu = (() => {
  /** localStorage yazilamiyorsa kullanilacak yedek. */
  let bellek = null;

  function depoOku() {
    if (bellek) return new Set(bellek);
    try {
      const ham = window.localStorage.getItem(FAVORI_ANAHTARI);
      if (!ham) return new Set();
      const dizi = JSON.parse(ham);
      return new Set(Array.isArray(dizi) ? dizi.map(String) : []);
    } catch {
      // Bozuk/okunamaz kayit: bos listeyle devam et, kullaniciya hata gosterme.
      return new Set();
    }
  }

  function depoYaz(kume) {
    const dizi = [...kume];
    try {
      window.localStorage.setItem(FAVORI_ANAHTARI, JSON.stringify(dizi));
      bellek = null;
    } catch {
      bellek = dizi;
    }
  }

  return {
    /** @returns {boolean} */
    icinde(id) {
      return depoOku().has(String(id));
    },

    /** @returns {boolean} yeni durum (true = favoride) */
    cevir(id) {
      const anahtar = String(id);
      const kume = depoOku();
      const eklendi = !kume.has(anahtar);

      if (eklendi) kume.add(anahtar);
      else kume.delete(anahtar);

      depoYaz(kume);
      document.dispatchEvent(
        new CustomEvent(FAVORI_OLAYI, { detail: { id: anahtar, favoride: eklendi } })
      );
      return eklendi;
    },

    /** @returns {string[]} senkron katmani ve ileride favoriler sayfasi icin */
    tumu() {
      return [...depoOku()];
    },
  };
})();

window.campioneFavoriler = favoriDeposu;

if (!window.customElements.get('campione-favorite')) {
  class CampioneFavorite extends HTMLElement {
    #buton = null;
    #olayaBagli = null;

    connectedCallback() {
      this.#buton = this.querySelector('[data-campione-favorite]');
      if (!this.#buton) return;

      this.#durumuYaz(favoriDeposu.icinde(this.#urunId));

      this.#buton.addEventListener('click', this.#tiklama);

      // Ayni urun sayfada birden fazla yerde olabilir (ornegin oneriler
      // serididi). Birinde cevrilen kalp otekinde de degissin.
      this.#olayaBagli = (event) => {
        if (String(event.detail?.id) !== this.#urunId) return;
        this.#durumuYaz(Boolean(event.detail.favoride));
      };
      document.addEventListener(FAVORI_OLAYI, this.#olayaBagli);
    }

    disconnectedCallback() {
      this.#buton?.removeEventListener('click', this.#tiklama);
      if (this.#olayaBagli) document.removeEventListener(FAVORI_OLAYI, this.#olayaBagli);
    }

    get #urunId() {
      return String(this.getAttribute('product-id') || '');
    }

    /*
     * Kart tiklaninca urune gitmesin diye preventDefault/stopPropagation sart:
     * buton <a class="product-card__media"> ile ayni figure icinde duruyor.
     */
    #tiklama = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!this.#urunId) return;
      this.#durumuYaz(favoriDeposu.cevir(this.#urunId));
    };

    #durumuYaz(favoride) {
      this.#buton.setAttribute('aria-pressed', favoride ? 'true' : 'false');
      const etiket = favoride
        ? this.getAttribute('label-remove')
        : this.getAttribute('label-add');
      if (etiket) this.#buton.setAttribute('aria-label', etiket);
    }
  }

  window.customElements.define('campione-favorite', CampioneFavorite);
}

/*
 * Favori senkronu — cihazlar arasi tasima.
 *
 * Yerel liste (yukaridaki favoriDeposu) HER ZAMAN calisir: misafir musteride,
 * sunucu kapaliyken, app proxy tanimli degilken bile. Bu katman yalnizca
 * GIRIS YAPMIS musteride devreye girer ve listeyi sunucuya tasir:
 *
 *   tarayici -> /apps/favoriten  (magazanin kendi alan adi)
 *      -> Shopify imzalar + musteri numarasini ekler
 *         -> connector.zehra.app/proxy/favorites
 *
 * Musteri numarasini biz gondermiyoruz; Shopify ekliyor. Yani buradaki
 * istekler kimlik tasimiyor, taklit edilemez.
 *
 * BIRLESTIRME KURALI (sirasi onemli):
 * - Misafirken favori ekleyip sonra giris yapan: yerel liste sunucuya EKLENIR
 *   (kaybolmaz). Bu birlesme bir tarayicida musteri basina BIR KEZ yapilir.
 * - Sonraki ziyaretlerde sunucu dogruyu soyler: liste sunucudan CEKILIR ve
 *   yereli degistirir. Boylece telefonda kaldirilan urun masaustunde de gider;
 *   her acilista birlestirseydik silinen urun geri dirilirdi.
 * - Cikis yapilinca / baska hesaba gecilince yerel liste TEMIZLENIR. Ortak
 *   kullanilan bilgisayarda bir onceki musterinin listesi durmasin diye.
 *
 * Sunucuya ulasilamazsa hicbir sey olmaz: kalp yerel listeyle calismaya devam
 * eder, bir sonraki sayfada tekrar denenir.
 */
const FAVORI_UCU = '/apps/favoriten';
const FAVORI_SAHIBI_ANAHTARI = 'campione:favorites-owner';
const FAVORI_BIRLESTI_ANAHTARI = 'campione:favorites-merged';

const favoriSenkronu = (() => {
  function yerelOku(anahtar) {
    try {
      return window.localStorage.getItem(anahtar) ?? '';
    } catch {
      return '';
    }
  }

  function yerelYaz(anahtar, deger) {
    try {
      window.localStorage.setItem(anahtar, deger);
    } catch {
      /* gizli sekme / kota: senkron bu tarayicida calismaz, kalp yine calisir */
    }
  }

  function listeyiKoy(idler) {
    const oncekiler = new Set(favoriDeposu.tumu());
    const yeniler = new Set(idler.map(String));

    try {
      window.localStorage.setItem(FAVORI_ANAHTARI, JSON.stringify([...yeniler]));
    } catch {
      return;
    }

    // Degisen her urun icin olay yolla ki ekrandaki kalpler kendini duzeltsin.
    for (const id of new Set([...oncekiler, ...yeniler])) {
      const oncekiVar = oncekiler.has(id);
      const yeniVar = yeniler.has(id);
      if (oncekiVar === yeniVar) continue;
      document.dispatchEvent(
        new CustomEvent(FAVORI_OLAYI, { detail: { id, favoride: yeniVar, kaynak: 'senkron' } })
      );
    }
  }

  async function cagir(secenekler) {
    const yanit = await fetch(FAVORI_UCU, {
      ...secenekler,
      headers: { 'content-type': 'application/json' },
    });
    // App proxy tanimli degilse Shopify 404 + HTML doner; sessizce cekilelim.
    if (!yanit.ok) return null;
    const veri = await yanit.json().catch(() => null);
    return veri && veri.ok && Array.isArray(veri.ids) ? veri : null;
  }

  return {
    async baslat() {
      const musteri = document.body?.dataset.campioneCustomer || '';
      const oncekiSahip = yerelOku(FAVORI_SAHIBI_ANAHTARI);

      // Cikis ya da hesap degisikligi: onceki musterinin listesi burada kalmasin.
      const hesapDegisti = oncekiSahip && oncekiSahip !== musteri;
      if (hesapDegisti) {
        listeyiKoy([]);
        yerelYaz(FAVORI_BIRLESTI_ANAHTARI, '');
      }
      yerelYaz(FAVORI_SAHIBI_ANAHTARI, musteri);

      if (!musteri) return; // misafir: yalnizca yerel

      try {
        const birlesti = yerelOku(FAVORI_BIRLESTI_ANAHTARI) === musteri;

        if (!birlesti) {
          // Ilk kez: misafirken eklenenleri sunucuya tasi, birlesigi geri al.
          const veri = await cagir({
            method: 'POST',
            body: JSON.stringify({ add: favoriDeposu.tumu() }),
          });
          if (!veri) return;
          listeyiKoy(veri.ids);
          yerelYaz(FAVORI_BIRLESTI_ANAHTARI, musteri);
          return;
        }

        const veri = await cagir({ method: 'GET' });
        if (veri && !veri.anonymous) listeyiKoy(veri.ids);
      } catch {
        /* sunucuya ulasilamadi: yerel liste yeterli, bir sonraki sayfada yine denenir */
      }
    },

    /** Tek bir degisikligi sunucuya bildirir (bekletmeden). */
    bildir(id, favoride) {
      if (!document.body?.dataset.campioneCustomer) return;
      cagir({
        method: 'POST',
        body: JSON.stringify(favoride ? { add: [id] } : { remove: [id] }),
      }).catch(() => {
        /* sessiz: yerel kayit zaten yapildi */
      });
    },
  };
})();

document.addEventListener(FAVORI_OLAYI, (event) => {
  // Sunucudan gelen degisikligi tekrar sunucuya yollamayalim (dongu olur).
  if (event.detail?.kaynak === 'senkron') return;
  favoriSenkronu.bildir(String(event.detail?.id), Boolean(event.detail?.favoride));
});

favoriSenkronu.baslat();
